<template>
  <a @click="toDetail(article)">
    <div class="imgbox">
      <img :src="article.files" alt="" />
    </div>
    <div class="txtbox">
      <!-- <b>2024-07-17</b> -->
      <h3>
        {{ article.title }}
      </h3>
      <p>
        {{ article.des }}
      </p>
      <span @click="toDetail(article)">查看详情</span>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
    activeCode: {
      type: String,
      default: 'xinwendongtai',
    },
    activeTabId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    toDetail(article) {
      console.log(article, this.activeTabId, '1111111')
      if (article.url != '') {
        window.open(article.url)
      } else {
        this.$router.push({
          path: '/portalDetails',
          query: {
            id: article.id,
            activeCode: this.activeCode,
            code: article.pname == '党建园地' ? 'dangjianyuandi' : '',
            columnId: this.activeTabId,
          },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.css";
@import "../style/global.css";
@import "../style/news.css";
</style>
